
document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.swiper-container', {
    direction: "horizontal",
    slidesPerView: 3.3,
    spaceBetween: 40,
    loop: false,
    mousewheelSensitivity: 1,
    grabCursor:true,
    touchEventsTarget:'wrapper',
    mousewheel: {
      releaseOnEdges: true,
      forceToAxis:true
    },
    // freeMode: {
    //   enabled: true,
    //   sticky: false,
    //   momentumBounce: false,
    // },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
      },
      640: {
        slidesPerView: 2.5,
      },
      1000: {
        slidesPerView: 3.3,
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
    effect: 'slide', // Dodavanje efekta 'slide' za tranziciju između slajdova
    speed: 1000, // Brzina tranzicije (800 milisekundi)
  });
});


document.addEventListener("DOMContentLoaded", function() {
  // Add event listener to color-list items
  var colorItems = document.querySelectorAll('.hero-product .color-list-item');
  colorItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // Remove 'active' class from all items
      colorItems.forEach(function (item) {
        item.classList.remove('active');
      });
      // Add 'active' class to the clicked item
      this.classList.add('active');

      // Hide all images and remove fadeIn class
      var images = document.querySelectorAll('.hero-product .col-lg-6 img');
      images.forEach(function (img) {
        img.classList.add('d-none'); 
        img.classList.remove('fadeInUp'); // Remove fadeIn class
      }); 
      // Show the corresponding image based on data-color-id
      var imageToShow = document.querySelector('.hero-product .col-lg-6 img[data-image-id="' + this.dataset.colorId + '"]');
      imageToShow.classList.remove('d-none');
      imageToShow.classList.add('animated', 'fadeInUp'); // Add animated and fadeIn classes

      // Get the background color from the clicked color item
      var backgroundColor = this.dataset.bgColor;

      // Apply the background color to the section with transition
      var heroSection = document.querySelector('.hero-product');
      heroSection.style.transition = "background-color 0.5s ease"; // Set transition
      heroSection.style.backgroundColor = backgroundColor;
    });
  });

  // Get background color from the initially active color
  var initialBackgroundColor = document.querySelector('.hero-product .color-list-item.active').dataset.bgColor;
  // Apply the initial background color to the section
  document.querySelector('.hero-product').style.backgroundColor = initialBackgroundColor;
});




(function ($) {
  $(function () { 


    // Pratimo skrolovanje korisnika
    window.addEventListener('scroll', function () {
      const timelineItems = document.querySelectorAll('.timeline-container ul.tl li');

      // Iteriramo kroz svaki timeline item da proverimo da li je vidljiv u viewport-u
      timelineItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();

        // Proveravamo da li je item unutar viewport-a
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          // Dodajemo klasu 'active' na vidljivi item
          item.classList.add('active');
        } else {
          // Uklanjamo klasu 'active' sa svih ostalih item-a
          item.classList.remove('active');
        }
      });
    });


    // Dodajte klasu "active" kada je slika u viewport-u
    window.addEventListener('scroll', function () {
      const img = document.getElementById('meet-img');
      const rect = img.getBoundingClientRect();

      if (rect.top < window.innerHeight && rect.bottom >= 0) {
        // Slika je vidljiva u viewport-u, dodajemo klasu "active"
        img.classList.add('active');
      } else {
        // Slika nije vidljiva u viewport-u, uklanjamo klasu "active"
        img.classList.remove('active');
      }
    });



    const onScrollID = (_this, offsetValue) => {
      // e.preventDefault();
      // target element id
      var id = _this.attr('href');

      // target element
      var $id = $(id);
      if ($id.length === 0) {
        return;
      }

      var pos = $id.offset().top + offsetValue;

      // animated top scrolling
      $('body, html').animate({
        scrollTop: pos
      });
    }

    $(document).on('click', 'a.navbar-brand, .navbar a[href^="#"], .scroll-down', function (e) {
      const _this = $(this)
      onScrollID(_this, -50);
    });


    function updateActiveNavigationLink() {
      const navigationLinks = document.querySelectorAll('#primary-menu a');
      const scrollPosition = window.scrollY;

      navigationLinks.forEach(link => {
        const href = link.getAttribute('href');

        if (href.startsWith('#')) { // Preskačemo linkove koji ne vode na sekcije unutar iste stranice
          const sectionId = href;
          const section = document.querySelector(sectionId);

          if (section) {
            const sectionOffsetTop = section.offsetTop - 200;
            const sectionHeight = section.offsetHeight;

            const listItem = link.closest('li'); // Pronalazi najbliži roditeljski li element

            if (scrollPosition >= sectionOffsetTop && scrollPosition < sectionOffsetTop + sectionHeight) {
              listItem.classList.add('active'); // Dodaje active klasu na roditeljski li element
            } else {
              listItem.classList.remove('active'); // Uklanja active klasu sa roditeljskog li elementa
            }
          }
        }
      });
    }

    // Dodavanje događaja za skrol
    window.addEventListener('scroll', updateActiveNavigationLink);

    AOS.init();


    $('.nav-button').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.navigation-floating').toggleClass('opened');
      $('.overlay-black').addClass('active');

    });

    $('.nav-button.active').on('click', function () {
      $(this).removeClass('active');
      $('.navigation-floating.opened').removeClass('opened');
    });

    /*
     * Navbar fixed 
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top fadeInDown animated');
      } else {
        $('.site-header').removeClass('navbar-fixed-top fadeInDown animated');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });



    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });



    /*
     * Mmenu light 
     */
    var menu = new MmenuLight(
      document.querySelector('#my-menu'),
      'all'
    );
    if (menu) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Menu'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }

  });
})(jQuery);

let state = {
  material : null,
  color : null,
  size : null,
  bowlColor : null
};

const imageMap ={
  wood:{
    default: "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png",
    white:{
      default: "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png",
      gold: "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png",
      silver: "/wp-content/uploads/2024/11/WiFeed-bela-i-hrom.png",
      black: "/wp-content/uploads/2024/11/WiFeed-bela-i-crno.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-bela-i-bakar.png"
    },
    black:{
      default: "/wp-content/uploads/2024/11/WiFeed-crna-i-bakar.png",
      gold: "/wp-content/uploads/2024/11/WiFeed-crna-i-zlatna.png",
      silver: "/wp-content/uploads/2024/11/WiFeed-crna-i-hrom.png",
      black: "/wp-content/uploads/2024/11/WiFeed-crna-i-crna.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-crna-i-bakar.png"
    },
    chocolate:{
      default: "/wp-content/uploads/2024/11/WiFeed-braon-tamno-i-bakar.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-braon-tamno-i-zlatno.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-braon-tamno-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-braon-tamno-i-crno.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-braon-tamno-i-bakar.png"
    }
  },
  metal:{
    default: "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png",
    white:{
      default: "/wp-content/uploads/2024/11/WiFeed-beli-metal-i-zlatno.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-beli-metal-i-zlatno.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-beli-metal-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-beli-metal-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-beli-metal-i-bakar.png"
    },
    black:{
      default: "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-bakar.png"

    },
    metallic:{
      default: "/wp-content/uploads/2024/11/WiFeed-metalik-i-zlatno.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-metalik-i-zlatno.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-metalik-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-metalik-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-metalik-i-bakar.png"
    }
  }
};
const bowlMap = {
   wood:{
    default: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-zlato.png",
    white:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-zlato.png",
      gold: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-zlato.png",
      silver: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-hrom.png",
      black: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-crno.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-bakar.png"
    },
    black:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-crno-drvo-i-zlatno.png",
      gold: "/wp-content/uploads/2024/11/WiFeed-zoom-crno-drvo-i-zlatno.png",
      silver: "/wp-content/uploads/2024/11/WiFeed-zoom-crno-drvo-i-hrom.png",
      black: "/wp-content/uploads/2024/11/WiFeed-zoom-crno-drvo-i-crno.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-zoom-crno-drvo-i-bakar.png"
    },
    chocolate:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-tamno-braon-drvo-i-zlato.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-zoom-tamno-braon-drvo-i-zlato.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-zoom-tamno-braon-drvo-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-zoom-tamno-braon-drvo-i-crno.png",
      bronze: "/wp-content/uploads/2024/11/WiFeed-zoom-tamno-braon-drvo-i-bakar.png"
    }
  },
  metal:{
    default: "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-zlatno.png",
    white:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-metal-beli-i-zlato.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-beli-i-zlato.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-beli-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-beli-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-beli-i-bakar.png"
    },
    black:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-zlatno.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-zlatno.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-bakar.png"

    },
    metallic:{
      default: "/wp-content/uploads/2024/11/WiFeed-zoom-metal-sivi-i-zlato.png",
      gold : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-sivi-i-zlato.png",
      silver : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-sivi-i-hrom.png",
      black : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-sivi-i-crno.png",
      bronze : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-sivi-i-bakar.png"
    }
  }
  
};
function colorSwitch(color){
  if(siteLanguage.language != 'en'){
     switch(color){
      case 'black':
        return 'Crna';
      case 'white':
        return 'Bela';
      case 'chocolate':
        return 'Čokolada';
      case 'metallic':
        return 'Metalik';
   }
 }else{
  switch(color){
    case 'black':
      return 'Black';
    case 'white':
      return 'White';
    case 'chocolate':
      return 'Chocolate';
    case 'metallic':
      return 'Metallic';
 }
 }
}
function switchMaterial(material){
  if(siteLanguage.language != 'en'){
    switch(material){
      case 'wood':
        return 'Drvo';
      case 'metal' :
        return 'Metal'
    }
  }else{
    switch(material){
      case 'wood':
        return 'Wood';
      case 'metal' :
        return 'Metal'
    }
  }
}
function switchBowlColor(modalBowlColor){
  if(siteLanguage.language != 'en'){
    switch(modalBowlColor){
      case 'gold':
        return 'Zlatna';
      case 'silver' :
        return 'Srebrna';
      case 'black':
        return 'Crna';
      case 'bronze':
        return 'Bronzana';
    }
  }else{
    switch(modalBowlColor){
      case 'gold':
        return 'Gold';
      case 'silver' :
        return 'Silver';
      case 'black':
        return 'Black';
      case 'bronze':
        return 'Bronze';
    }
  }
}

document.addEventListener('DOMContentLoaded', function (){
  const modelSelector = document.getElementById("model-selector");
  if(!modelSelector) return;

  const materialButtons = modelSelector.querySelectorAll('.material-selector');
  const colorButtons = modelSelector.querySelectorAll('.color-circle');
  const feederImage = modelSelector.querySelector('#finalImage');
  const bowlImage = modelSelector.querySelector('#bowlImage1');
  const materialImage = modelSelector.querySelector('#materialImage');
  const colorImage = modelSelector.querySelector('#colorImage');
  const sizeImage = modelSelector.querySelector('#sizeImage');
  const sizeButtons = modelSelector.querySelectorAll(".sizeSelect");
  const bowlButtons = modelSelector.querySelectorAll('.bowl-color-circle');
  const specificButton = modelSelector.querySelector('#specific-button');
  const bowlColorText = modelSelector.querySelector('.bowl-selected-color');
  const selectedColorText = modelSelector.querySelector('.selected-color');
  const sizeToggle = modelSelector.querySelector('#measurementToggle');
  const smallPrice = document.querySelector("#smallPrice");
  const mediumPrice = document.querySelector("#mediumPrice");
  const largePrice = document.querySelector("#largePrice");

  const orderModal = modelSelector.querySelector('#orderModal');
  const order = modelSelector.querySelector('#orderButton');

  const sizes = {
    S: {
      mm: {
        duzina: '320 mm',
        sirina: '330 mm',
        visina: '600 mm',
        zapremina: '3.2 kg'
      },
      inch: {
        duzina: '12.6 in',
        sirina: '12.99 in',
        visina: '23.62 in',
        zapremina: '7.09 lbs'
      }
    },
    M: {
      mm: {
        duzina: '360 mm',
        sirina: '370 mm',
        visina: '780 mm',
        zapremina: '5.5 kg'
      },
      inch: {
        duzina: '14.17 in',
        sirina: '14.57 in',
        visina: '30.71 in',
        zapremina: '12.13 lbs'
      }
    },
    L: {
      mm: {
        duzina: '470 mm',
        sirina: '420 mm',
        visina: '1050 mm',
        zapremina: '10 kg'
      },
      inch: {
        duzina: '18.5 in',
        sirina: '16.54 in',
        visina: '41.34 in',
        zapremina: '22.04 lbs'
      }
    }
  };
  
  const sizeText = {
    duzina: modelSelector.querySelector('#feederLength'),
    sirina: modelSelector.querySelector('#feederWidth'),
    visina: modelSelector.querySelector('#feederHeight'),
    zapremina: modelSelector.querySelector('#feederVolume')
  };
  function updateImages(){
    if (state.material) {
      
      const materialImgPath = state.material == 'wood' ? "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png" : '/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png';
      materialImage.src = materialImgPath;
      colorImage.src=materialImgPath;
      
      const sizeImgPath = state.material == 'wood' ? "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png" : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png";
      sizeImage.src= sizeImgPath;

      const bowlImagePath = state.material == 'wood' ? "/wp-content/uploads/2024/11/WiFeed-zoom-belo-drvo-i-zlato.png" : "/wp-content/uploads/2024/11/WiFeed-zoom-metal-crni-i-zlatno.png";
      bowlImage.src = bowlImagePath;

      const finalImgPath = state.material == 'wood' ? "/wp-content/uploads/2024/11/WiFeed-bela-i-zlatno.png" : "/wp-content/uploads/2024/11/WiFeed-crni-metal-i-zlatno.png";
      feederImage.src = finalImgPath;
    }

    if (state.color) {
      const colorImgPath = imageMap[state.material]?.[state.color].default || "";
      console.log(colorImgPath);
      materialImage.src=colorImgPath;
      colorImage.src = colorImgPath;
      sizeImage.src = colorImgPath;
      feederImage.src = colorImgPath;
      bowlImage.src = bowlMap[state.material]?.[state.color]?.default || '';
    }

    if (state.bowlColor) {
      const bowlImgPath = bowlMap[state.material]?.[state.color]?.[state.bowlColor] || '';
      console.log(bowlImgPath);
      bowlImage.src = bowlImgPath;
      
    }

    if (state.material && state.color && state.bowlColor) {
      const feederImgPath = imageMap[state.material]?.[state.color]?.[state.bowlColor] || '';
      console.log(feederImgPath);
      feederImage.src = feederImgPath;
      sizeImage.src = feederImgPath;
      colorImage.src=feederImgPath;
      materialImage.src=feederImgPath;
      
    }
  }
  function deselectButtons(buttonGroup) {
    buttonGroup.forEach(button => button.classList.remove('selected'));
  }
  function updateSizeSpec(size,unit){
    const specs = sizes[size][unit];
    sizeText.duzina.innerHTML =(siteLanguage.language != 'en') ? `Dužina: <strong>${specs.duzina}</strong>` : `Length: <strong>${specs.duzina}</strong>`;
    sizeText.sirina.innerHTML = (siteLanguage.language != 'en') ?  `Širina: <strong>${specs.sirina}</strong>` : `Width: <strong>${specs.sirina}</strong>`;
    sizeText.visina.innerHTML =(siteLanguage.language != 'en') ?  `Visina: <strong>${specs.visina}</strong>` : `Height: <strong>${specs.visina}</strong>`;
    sizeText.zapremina.innerHTML = (siteLanguage.language != 'en') ?  `Zapremina: <strong>${specs.zapremina}</strong>` : `Volume: <strong>${specs.zapremina}</strong>` ;
    console.log("Okinuta fja updateSize");
  }
  function updateSizePrices(){
    if(siteLanguage.language != 'en'){
      smallPrice.innerHTML = (state.material != 'metal') ? 'Počevši od €499.00' : 'Počevši od €549.00' ;
      mediumPrice.innerHTML = (state.material != 'metal') ? 'Počevši od €549.00' : 'Počevši od €599.00' ;
      largePrice.innerHTML = (state.material != 'metal') ? 'Počevši od €599.00' : 'Počevši od €649.00' ;
    }else{
      smallPrice.innerHTML = (state.material != 'metal') ? 'Starting from €499.00' : 'Starting from €549.00' ;
      mediumPrice.innerHTML = (state.material != 'metal') ? 'Starting from €549.00' : 'Starting from €599.00' ;
      largePrice.innerHTML = (state.material != 'metal') ? 'Starting from €599.00' : 'Starting from €649.00' ;
      
    }
  }
  
  
    if (!sizeToggle) return;
  
    let currentUnit = 'mm'; // Default unit
    sizeToggle.addEventListener('click', () => {
      
      currentUnit = currentUnit === 'mm' ? 'inch' : 'mm';
  
      
      const selectedSize = state.size || 'M'; 
      const specs = sizes[selectedSize][currentUnit];
  
     
      sizeText.duzina.innerHTML =(siteLanguage.language != 'en') ? `Dužina: <strong>${specs.duzina}</strong>` : `Length: <strong>${specs.duzina}</strong>`;
      sizeText.sirina.innerHTML = (siteLanguage.language != 'en') ?  `Širina: <strong>${specs.sirina}</strong>` : `Width: <strong>${specs.sirina}</strong>`;
      sizeText.visina.innerHTML =(siteLanguage.language != 'en') ?  `Visina: <strong>${specs.visina}</strong>` : `Height: <strong>${specs.visina}</strong>`;
      sizeText.zapremina.innerHTML = (siteLanguage.language != 'en') ?  `Zapremina: <strong>${specs.zapremina}</strong>` : `Volume: <strong>${specs.zapremina}</strong>` ;

      updateSizeSpec(state.size, currentUnit);
    });
  
  materialButtons.forEach(button =>{
    button.addEventListener('click', function ()  {
      state.material = this.id === 'woodSelect' ? 'wood' : 'metal' ;
      state.color = state.color? state.color : null;
      state.bowlColor = state.bowlColor? state.bowlColor : null;
      console.log(state.material)
      if(specificButton.classList.contains('chocolate') && state.material == 'metal'){
        specificButton.classList.remove('chocolate');
        specificButton.classList.add('silver');
      }
      else if(specificButton.classList.contains('silver') && state.material == 'wood'){
        specificButton.classList.remove('silver');
        specificButton.classList.add('chocolate');
      }
      else{
        
      }
      deselectButtons(materialButtons);
      this.classList.add('selected');
      updateImages();
      updateSizePrices();
    });
  });
  colorButtons.forEach(button => {
    button.addEventListener('click', function() {
      const color = button.classList.contains('white') ? 'white' :
      button.classList.contains('black') ? 'black' :
      button.classList.contains('chocolate')? 'chocolate' : 'metallic';
      if(color == 'white'){
        selectedColorText.innerHTML =(siteLanguage.language != 'en') ? `Boja - Bela` : `Color - White`;
      }
      else if( color == 'black' ){
        selectedColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Crna` : `Color - Black`;
      }
      else if(color == 'chocolate'){
        selectedColorText.innerHTML =(siteLanguage.language != 'en') ? `Boja - Čokolada` : `Color - Chocolate`
      }
      else{
        selectedColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Metalik` : `Color - Metallic`
      }
      if(!state.material){
        alert((siteLanguage.language != 'en') ? `Prvo izaberite materijal` : `Please select a material first`);
        modelSelector.scrollIntoView({behavior:"smooth"});
      }
      if(state.material && color){
        state.color = color;
        state.bowlColor = state.bowlColor? state.bowlColor : null;
        console.log(state.color);
        deselectButtons(colorButtons);
        this.classList.add('selected');
        updateImages();
      }
    });
  });
  bowlButtons.forEach(button => {
    button.addEventListener('click', function (){
      const bowl = button.classList.contains('gold') ? 'gold' :
       button.classList.contains('black') ? 'black' :
       button.classList.contains('silver') ? 'silver' : 'bronze';
       
       if(bowl == 'gold'){
        bowlColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Zlatna` : `Color - Gold`;
       }
       else if(bowl == 'black'){
        bowlColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Crna` : `Color - Black`;
       }
       else if(bowl == 'silver'){
        bowlColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Srebrna` : `Color - Silver`;
       }
       else{
        bowlColorText.innerHTML = (siteLanguage.language != 'en') ? `Boja - Bronzana` : `Color - Bronze`;
       }
       if(!state.material || !state.color){
        modelSelector.scrollIntoView({behavior:"smooth"});
        if(siteLanguage.language != 'en'){
          alert("Molimo Vas prvo izaberite boju i/ili materijal.");
        }
        else{
          alert("Please select a color and/or material.")
        }
       }
       if(state.material && state.color && bowl){
        state.bowlColor = bowl;
        console.log(state.bowlColor)
        deselectButtons(bowlButtons);
        this.classList.add('selected');
        updateImages();
       }
    });
  });
  sizeButtons.forEach(button => {
    button.addEventListener('click', function () {
      const size = button.id.includes('small') ? 'S' :
        button.id.includes('medium') ? 'M' : 'L';
      state.size = size;
      sizeImage.classList.remove('smaller', 'bigger', 'normal');
      sizeImage.classList.add(size === 'S' ? 'smaller' : size === 'L' ? 'bigger' : 'normal');
      deselectButtons(sizeButtons);
      this.classList.add('selected');
      updateSizeSpec(size,currentUnit);
    });
  });
  function viewOrder(state){
    const modalContent = modelSelector.querySelector('#orderModal .modal-content');

    modalContent.innerHTML = '';

    modalContent.innerHTML = siteLanguage.language != 'en' ? //SRPSKI DEO --------------------------------------------------------------------------------------------------
     `<button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-top:20px;>
        <span aria-hidden="true">&times;</span>
      </button>
     <div class = "builtFeeder">
        <div class = "row">
          <div class = "col-lg-6 specs">
            <div class="col-lg-6">
              <p>Material : </p>
              <p>Color : </p>
              <p>Size: </p>
              <p>Bowl color: </p>
            </div>
            <div class="col-lg-6">
              <p><strong>${switchMaterial(state.material)}</strong></p>
              <p><strong>${colorSwitch(state.color)}</strong></p>
              <p><strong>${state.size}</strong> </p>
              <p><strong>${switchBowlColor(state.bowlColor)}</strong></p>
            </div>
          </div>
          <div class = "col-lg-6">
            <img src = ${imageMap[state.material]?.[state.color]?.[state.bowlColor]} id="modalFeederImg" />
          </div>
        </div>
      </div>
      <form action="URL DO SAJTA" method="POST" id="orderForm" >
  <div class="modal-form ">
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <p>
            <label for="ime">Ime</label><br>
            <span class="wpcf7-form-control-wrap" data-name="ime">
              <input
                size="40"
                maxlength="400"
                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                id="ime"
                aria-required="true"
                aria-invalid="false"
                placeholder="Ime:"
                value=""
                type="text"
                name="ime"
                required
              />
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <p>
            <label for="prezime">Prezime</label><br>
            <span class="wpcf7-form-control-wrap" data-name="prezime">
              <input
                size="40"
                maxlength="400"
                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                id="prezime"
                aria-required="true"
                aria-invalid="false"
                placeholder="Prezime:"
                value=""
                type="text"
                name="prezime"
                required
              />
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <p>
            <label for="telefon">Telefon</label><br>
            <span class="wpcf7-form-control-wrap" data-name="telefon">
              <input
                size="40"
                maxlength="400"
                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                id="telefon"
                aria-required="true"
                aria-invalid="false"
                placeholder="Broj telefona:"
                value=""
                type="text"
                name="telefon"
                required
              />
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <p>
            <label for="email">E-mail</label><br>
            <span class="wpcf7-form-control-wrap" data-name="email">
              <input
                size="40"
                maxlength="400"
                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                id="email"
                aria-required="true"
                aria-invalid="false"
                placeholder="E-mail:"
                value=""
                type="email"
                name="email"
                required
              />
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 w-100 d-flex justify-content-center">
        <input
          id="posalji-dugme"
          type="submit"
          class="btn btn-secondary  mb-3 submit"
          value="Pošalji"
        />
      </div>
    </div>
  </div>
</form>

  <div class="col-lg-12 modal-footer">
    <p class="question">Imate još pitanja?</p>
    <a class="btn btn-secondary " href="http://wifeedwp.dev.itcentar.rs//kontaktirajte-nas/#contact-form">Pišite nam</a>
  </div>
    `: //ENGLESKI DEO ---------------------------------------------------------------------------------------------------------------------------
    `<button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-top:20px;">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class = "builtFeeder">
        <div class = "row">
          <div class = "col-lg-6 specs">
            <div class="col-lg-6">
              <p>Material : </p>
              <p>Color : </p>
              <p>Size: </p>
              <p>Bowl color: </p>
            </div>
            <div class="col-lg-6">
              <p><strong>${switchMaterial(state.material)}</strong></p>
              <p><strong>${colorSwitch(state.color)}</strong></p>
              <p><strong>${state.size} </strong></p>
              <p><strong>${switchBowlColor(state.bowlColor)}</strong></p>
            </div>
          </div>
          <div class = "col-lg-6">
            <img src = ${imageMap[state.material]?.[state.color]?.[state.bowlColor]} id="modalFeederImg" />
          </div>
        </div>
      </div>
      <form action="URL" method="POST" id="orderForm">
        <div class="modal-form">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <p>
                  <label for="firstName">First Name</label><br>
                  <span class="wpcf7-form-control-wrap" data-name="firstName">
                    <input
                      size="40"
                      maxlength="400"
                      class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                      id="firstName"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="First Name:"
                      value=""
                      type="text"
                      name="firstName"
                      required
                    />
                  </span>
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <p>
                  <label for="lastName">Last Name</label><br>
                  <span class="wpcf7-form-control-wrap" data-name="lastName">
                    <input
                      size="40"
                      maxlength="400"
                      class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                      id="lastName"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="Last Name:"
                      value=""
                      type="text"
                      name="lastName"
                      required
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <p>
                  <label for="phone">Phone</label><br>
                  <span class="wpcf7-form-control-wrap" data-name="phone">
                    <input
                      size="40"
                      maxlength="400"
                      class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                      id="phone"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="Phone Number:"
                      value=""
                      type="text"
                      name="phone"
                      required
                    />
                  </span>
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <p>
                  <label for="email">Email</label><br>
                  <span class="wpcf7-form-control-wrap" data-name="email">
                    <input
                      size="40"
                      maxlength="400"
                      class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                      id="email"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="Email:"
                      value=""
                      type="email"
                      name="email"
                      required
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 w-100 d-flex justify-content-center">
              <input
                id="posalji-dugme"
                type="submit"
                class="btn btn-secondary  mb-3 submit"
                value="Submit"
              />
            </div>
          </div>
        </div>
      </form>
    <div class="col-lg-12 modal-footer">
<p class="question">Do you have more questions?</p>
<a class="btn btn-secondary " href="http://wifeedwp.dev.itcentar.rs//kontaktirajte-nas/#contact-form">Write to us</a>`;
  }
 
    order.addEventListener('click', () =>{
      if(state.material && state.color && state.size && state.bowlColor){
      viewOrder(state);

      }
      else{
        alert("Molimo Vas izaberite specifikacije vašeg modela.")

        const modalObject = bootstrap.Modal.getInstance(orderModal)
       if(modalObject) modalObject.dispose();
      }
    })
  
});

//Bowl Color For Sevices Page
document.addEventListener('DOMContentLoaded', function () {
  const dodaciSection = document.getElementById("dodaci");
  if(!dodaciSection) return;
  const colorOptions = document.querySelectorAll('.color-circle');
  const selectedColorText = document.querySelector('.selected-color');
  const bowlImage = document.getElementById('bowlImage');


  
  

  const bowlColors = {
      gold: { name: {serbian: 'Zlatna', english : 'Gold'}, url: '/wp-content/uploads/2024/11/Zlatna-cinija.png' },
      black: { name: { serbian : 'Crna', english: 'Black' }, url: '/wp-content/uploads/2024/11/Crna-cinija.png' },
      silver: { name: { serbian: 'Srebrna', english: 'Silver'}, url: '/wp-content/uploads/2024/11/Metalna-cinija.png' },
      bronze: { name: {serbian:'Bronzana', english: 'Bronze'}, url: '/wp-content/uploads/2024/11/Bakarna-cinija.png' },
      
  };

  colorOptions.forEach(option => {
      option.addEventListener('click', function () {
          colorOptions.forEach(opt => opt.classList.remove('selected'));
          
          
          option.classList.add('selected');
          
          
          const colorKey = Array.from(option.classList).find(c => bowlColors[c]);
          
          
          if (colorKey) {
              selectedColorText.textContent =(siteLanguage.language != 'en') ? `Boja - ${bowlColors[colorKey].name.serbian}` : `Color - ${bowlColors[colorKey].name.english}`;
              bowlImage.src = bowlColors[colorKey].url;
              bowlImage.srcset = '';
              //console.log(colorKey);
          }
      });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const repeaterSection = document.querySelector(".repeater-section");
  if (!repeaterSection) return;

 
  const scrollTracker = document.createElement('div');
  scrollTracker.className = 'scroll-tracker';
  
  
  const sections = repeaterSection.querySelectorAll('.row > .d-flex');
  
  // Create tracker items based on number of sections
  sections.forEach((_, index) => {
      const trackerItem = document.createElement('a');
      trackerItem.className = 'tracker-item';
      trackerItem.href = `#section-${index + 1}`;
      scrollTracker.appendChild(trackerItem);
  });
  
  repeaterSection.appendChild(scrollTracker);

  // Get all tracker items after they're created
  const trackerItems = scrollTracker.querySelectorAll('.tracker-item');

  // Intersection Observer for the repeater section
  const repeaterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          scrollTracker.classList.toggle("visible", entry.isIntersecting);
      });
  }, { threshold: 0.1 });

  repeaterObserver.observe(repeaterSection);

  // Intersection Observer for sections with adjusted options
  const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              // Find the index of the current section
              const index = Array.from(sections).indexOf(entry.target);
              
              // Remove active class from all tracker items
              trackerItems.forEach(item => item.classList.remove("active"));
              
              // Add active class to current tracker item
              if (trackerItems[index]) {
                  trackerItems[index].classList.add("active");
              }

              // Debug log
              console.log('Section in view:', index);
          }
      });
  }, {
      threshold: [0.3], // Adjusted threshold
      rootMargin: "-30% 0px" // Adjusted root margin
  });

  // Add IDs and observe sections
  sections.forEach((section, index) => {
      section.id = `section-${index + 1}`;
      sectionObserver.observe(section);
      
      // Debug log
      console.log('Observing section:', index + 1);
  });

  // Smooth scroll functionality
  trackerItems.forEach(item => {
      item.addEventListener("click", (e) => {
          e.preventDefault();
          const targetId = item.getAttribute("href");
          const targetSection = document.querySelector(targetId);
          
          if (targetSection) {
              // Get header height (if you have a fixed header)
              const headerOffset = document.querySelector('header')?.offsetHeight || 0;
              
              const elementPosition = targetSection.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              });

              // Update active state immediately on click
              trackerItems.forEach(ti => ti.classList.remove("active"));
              item.classList.add("active");
          }
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".swiper-slide .item");
  const cardsMobile = document.querySelectorAll(".item");
  const questionGroups = document.querySelectorAll(".question-group");

  const activeCards = cards.length > 0 ? cards : cardsMobile;

  if (activeCards.length > 0) {
    activeCards[0].classList.add("item-active");
    questionGroups[0]?.classList.remove("d-none"); 

    activeCards.forEach((card, index) => {
      card.addEventListener("click", function () {
        activeCards.forEach((c) => c.classList.remove("item-active"));
        questionGroups.forEach((group) => group.classList.add("d-none"));

        card.classList.add("item-active");
        if (questionGroups[index]) {
          questionGroups[index].classList.remove("d-none");
          questionGroups[index].classList.add("accordion-active");

          if(window.innerWidth < 992){
            questionGroups[index].scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  } else {
    console.warn("No cards found for the current layout.");
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const navigateButton = document.getElementById('navigateToForm');
  const targetSection = document.getElementById('contact-form');
  const modal = document.getElementById('uputstvoModal');

  navigateButton.addEventListener('click', function (event) {
    event.preventDefault(); 

    $(modal).modal('hide'); 

    document.activeElement.blur();
    
    setTimeout(() => {
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300); 
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const shortToggle = document.getElementById('shortToggle');
  const longToggle = document.getElementById('longToggle');
  const timelineItems = document.querySelectorAll('.tl-item .item-detail');
  let shortContent = [''];
  let longContent = [''];

  if(siteLanguage.language != 'en'){
     shortContent = [
        'Kao vlasnici kućnih ljubimaca, dobro poznajemo osećaj brige kada ih ostavimo same, kao i million onih pitanja koja se javljaju. Da li će jesti na vreme? Da li im je hrana sveža?',
        'Upravo ove dileme podstakle su našu strast da stvorimo nešto drugačije — WiFeed, pametnu hranilicu koja omogućava da Vaši ljubimci dobiju negu koju zaslužuju, čak i kada niste kod kuće.',
        'WiFeed nije samo proizvod koji će potpomoći hranjenju ljubimaca; biće vasa pomoć u svakodnevnom organizovanju vremena. Sarađivali smo sa stručnjacima za ishranu ljubimaca i uzeli u obzir povratne informacije drugih vlasnika ljubimaca kako bismo kreirali rešenje koje osigurava da je on uvek nahranjen, srećan i zdrav—dok se istovremeno savršeno uklapa u svaki prostor.',
        'Naš moderan i elegantan dizajn spojen je sa pametnom tehnologijom koja čini brigu o ljubimcima lakšom i bez stresa.',
        'Ali tu nismo stali. Posvećeni smo i tome da ostavimo pozitivan uticaj na planetu. Zato WiFeed koristi ekološki prihvatljive materijale, nudeći održivo rešenje bez kompromisa na kvalitetu.',
        'Svaka hranilica je napravljena da traje, smanjujući otpad i omogućavajući vlasnicima ljubimaca da se osećaju dobro u vezi sa svojim izborima.',
        'Naša misija u WiFeed-u je jednostavna: donosimo radost ljubimcima i spokoj njihovim vlasnicima.',
        'Inovacije i izvrsnost su nam prioriteti, ne samo zbog profita, već sa ciljem da unapredimo živote ljubimaca i ljudi koji ih vole.'
    ];
     longContent = [
        'Iz zajedničke ljubavi prema životinjama i entuzijazma za pronalaženje inovativnih, ali estetski privlačnih rešenja, nastao je WiFeed.',
        'Dok je hranio napuštene pse na svojoj vikendici, Filip - član našeg tima, razmišljao je da li postoji mogućnost da im obezbedi adekvatnu ishranu čak i kada nije u blizini, a pritom da to učini na način koji bi bio u potpunosti bezbedan po životnu sredinu. Bleda ideja o modernoj pametnoj hranilici za kućne ljubimce koja se besprekorno uklapa u svako okruženje, ubrzo je dobila i svoj prvi nacrt.',
        'Višegodišnjim radom i saradnjom sa veterinarima i drugim ekspertima značajnim za ovu oblast, ali i konstantnom komunikacijom sa vlasnicima ljubimaca širom sveta, razvili smo i konačni izgled naše hranilice. Odlučili smo se za minimalistički dizajn koji omogućava njegovo lako uklapanje u svaki enterijer ili eksterijer, kao i jednostavno održavanje. ',
        'Upravo zato smo 2023. godine započeli razvojem svog brenda kada smo i postali dobitnici subvencije Inovacionog fonda Republike Srbije za proizvod sa velikim tržišnim potencijalom.',
        'Misija WiFeed tima je da stvara rešenja koja donose radost ljubimcima i mir njihovim vlasnicima. Stoga, fokus naše kompanije leži u pružanju kvalitetnog i unapređenog proizvoda, a ne u masovnoj proizvodnji koja isključivo teži ostvarenju profita.',
        'Kako smo i sami svesni izazova sa kojima se ljudi i životinje suočavaju svakodnevno, težićemo da kroz svoju poslovnu uspešnost ostvarimo značajne društvene promene i ostavimo dugotrajni trag podrške unutar naše zajednice kroz brojne inicijative. Donacija institucijama koja vrše uzgoj životinja koje se doniraju hendikepiranim licima, biće prva među našim brojnim doprinosima zajednici.',
        'Naše partnerstvo teži da uzvrati našim voljenim ljubimcima čak i mali deo beskrajne ljubavi koju nam pružaju, idući dalje od običnog industrijskog uticaja u industriji proizvoda za kućne ljubimce.',
        'Ali iznad toga, posvećeni smo i nalaženju rešenja koja nemaju negativan uticaj na životnu sredinu, osiguravajući da svaki korak koji preduzmemo ostavlja pozitivan trag.'
    ];
  }
  else{
     shortContent = [
      'As pet parents ourselves, we understand the worry that comes with leaving your furry companions alone. Will they eat on time? Is their food fresh? ',
      'This common concern sparked our passion to create something extraordinary - WiFeed, a smart pet feeder designed to give pets the care they deserve, even when their owners are away.',
      'WiFeed isn’t just about feeding pets; it’s about peace of mind. We collaborated with pet nutrition experts and gathered feedback from pet owners to create a solution that ensures your pet is always fed, happy, and healthy—while blending seamlessly into any environment. ',
      'Our sleek, modern design is paired with smart technology that makes pet care smarter and stress-free.',
      'But we didn’t stop there. We’re committed to making a positive impact on the planet too. That’s why WiFeed incorporates eco-conscious materials, offering a sustainable solution without compromising on quality.',
      'Every feeder is built to last, reducing waste and helping pet owners feel good about their choices.',
      'At WiFeed, our mission is simple: to bring joy to pets and peace of mind to their owners. ',
      'We prioritize innovation and excellence, not just for profit, but to truly elevate the lives of pets and the people who love them.'
  ];
   longContent = [
    'From a shared love for animals and enthusiasm for finding innovative yet aesthetically appealing solutions, WiFeed was born. ',
    'While feeding stray dogs at his weekend house, Filip - our team member pondered whether there was a possibility to provide them with adequate nutrition even when he wasn\'t around, all while doing so in a way that would be entirely environmentally safe.This faint idea of a modern smart pet feeder seamlessly blending into any environment, soon took shape with its first draft. ',
    'Through years of work and collaboration with veterinarians and other experts relevant to pet nutrition, along with constant communication with pet owners, we developed the final design of our feeder. We have opted for a minimalist design that allows easy integration into any interior or exterior space, as well as simple maintenance.',
    'That\'s why in 2023, we also embarked on developing our brand when we became recipients of a grant from the Innovation Fund of the Republic of Serbia for a product with an immense market potential.',
    'The mission of the WiFeed team is to create solutions that bring joy to pets and peace to their owners. Therefore, our company \'s focus lies in providing a quality and distinct product rather than mass production solely aimed at profit.',
    'Being aware of the challenges both people and animals face on a daily basis, we aim to achieve significant social changes through our business success and leave a lasting legacy of support within our community through numerous initiatives. Donating to institutions that breed animals destined to assist individuals with disabilities will be the first among our many contributions to the community.',
    'Our partnership strives to give back to our beloved pets even a small part of the endless love they provide us, going beyond mere industrial influence in the pet product industry. ',
    'But above all, we are committed to finding solutions that have no negative impact on the environment, ensuring that every step we take leaves a positive trace.'
];
  }
  


  function updateContent(content) {
      timelineItems.forEach((item, index) => {
          if (content[index]) {
              item.innerHTML = content[index];
          }
      });
  }


  shortToggle.addEventListener('click', function () {
      shortToggle.classList.add('selected');
      longToggle.classList.remove('selected');
      updateContent(shortContent);
  });

  longToggle.addEventListener('click', function () {
      longToggle.classList.add('selected');
      shortToggle.classList.remove('selected');
      updateContent(longContent);
  });

  updateContent(shortContent);
});

document.addEventListener("DOMContentLoaded", () => {
  const h2Elements = document.querySelectorAll("#luxury .text-image-content h2");

  if (h2Elements.length > 0) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const h2 = entry.target;

            // Start the animation
            h2.style.animationPlayState = "running";
            h2.style.opacity = "1";

            // Stop observing this element after animation starts
            observer.unobserve(h2);
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    // Observe all h2 elements
    h2Elements.forEach((h2) => {
      // Ensure initial paused state
      h2.style.animationPlayState = "paused";
      h2.style.opacity = "0";
      observer.observe(h2);
    });
  }
});

// document.addEventListener("DOMContentLoaded", () => {
//   const placeholders = document.querySelectorAll("#goal .text-image-content span");

//   if (placeholders.length > 0) {
//     const observer = new IntersectionObserver(
//       (entries, observer) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const span = entry.target;

//             // Start the animation
//             span.style.animationPlayState = "running";
//             span.style.opacity = "1";

//             // Stop observing this element
//             observer.unobserve(span);
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     // Initialize each span
//     placeholders.forEach((span) => {
//       span.style.animationPlayState = "paused";
//       span.style.opacity = "0";
//       observer.observe(span);
//     });
//   }
// });



